import React from "react";
import {
    HiPencilSquare,
    HiMagnifyingGlass,
    HiUsers,
    HiCheckBadge,
} from "react-icons/hi2";
import "./HowItWorks.scss";

const HowItWorks = () => {
    const steps = [
        {
            icon: <HiPencilSquare />,
            title: "Describe tu proyecto",
            description:
                "Cuéntanos qué necesitas: tipo de servicio, ubicación y requisitos técnicos",
        },
        {
            icon: <HiMagnifyingGlass />,
            title: "Atlyon analiza y conecta",
            description:
                "Analizamos tus necesidades y te conectamos con proveedores verificados",
        },
        {
            icon: <HiUsers />,
            title: "Colabora con el experto",
            description:
                "Trabaja con especialistas seleccionados por su experiencia y fiabilidad",
        },
        {
            icon: <HiCheckBadge />,
            title: "Recibe resultados precisos",
            description:
                "Obtén soluciones 3D de calidad que cumplan con todos tus objetivos",
        },
    ];

    return (
        <section id="how-it-works" className="how-it-works">
            <div className="how-it-works__container">
                <div className="how-it-works__header">
                    <h2 className="how-it-works__title">
                        ¿Cómo funciona Atlyon?
                    </h2>
                    <p className="how-it-works__description">
                        Atlyon actúa como una brújula digital que conecta a las
                        empresas con los mejores profesionales de la captura y
                        el modelado 3D. Solo tienes que describir tu proyecto:
                        tipo de servicio, ubicación y requisitos técnicos. A
                        partir de ahí, Atlyon analiza tus necesidades y te
                        conecta con proveedores verificados que se ajustan a tu
                        perfil. Nuestra red está formada por expertos en
                        escaneado láser y modelado 3D, seleccionados
                        cuidadosamente por su experiencia, equipamiento y
                        fiabilidad. Optimiza costes, reduce tiempos y trabaja
                        con especialistas que entienden tu entorno y tus
                        objetivos. Con Atlyon, navegar el mundo del 3D es más
                        simple, rápido y preciso.
                    </p>
                </div>

                <div className="how-it-works__journey">
                    {steps.map((step, index) => (
                        <React.Fragment key={index}>
                            <div className="journey-step">
                                <div className="journey-step__icon">
                                    {step.icon}
                                </div>
                                <h3 className="journey-step__title">
                                    {step.title}
                                </h3>
                                <p className="journey-step__description">
                                    {step.description}
                                </p>
                                <div className="journey-step__number">
                                    {index + 1}
                                </div>
                            </div>
                            {index < steps.length - 1 && (
                                <div className="journey-arrow">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
